import * as React from "react";
import { FGMaskInput } from "nsitools-react";
import { IconNames } from "@blueprintjs/icons";
import { Icon } from "@blueprintjs/core";

export interface IFGEuroMaskInputProps {
  name: string;
  label: string;
  readonly?: boolean;
}

export const FGEuroMaskInput: React.FunctionComponent<IFGEuroMaskInputProps> = ({ label, name, readonly = false }) => {
  return (
    <FGMaskInput
      rightElement={<Icon icon={IconNames.EURO} />}
      cleaveOptions={{
        numeralThousandsGroupStyle: "thousand",
        delimiter: ".",
      }}
      name={name}
      label={label}
      readonly={readonly}
    />
  );
};
